import { render, staticRenderFns } from "./ReportsBestUser.vue?vue&type=template&id=615fe900&"
import script from "./ReportsBestUser.vue?vue&type=script&lang=js&"
export * from "./ReportsBestUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports